export default "/assets/1666787ea3ff3941e7641817eb9edc94.woff2";